export default {
      id: "clock-warning-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#clock-warning",
      toString: function () {
        return this.url;
      }
    }